import {
  Directive,
  ElementRef,
  HostListener,
  forwardRef,
  Input,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Directive({
  selector: '[appCurrencyFormatter]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencyFormatterDirective),
      multi: true,
    },
  ],
})
export class CurrencyFormatterDirective implements ControlValueAccessor {
  @Input('appCurrencyFormatter') currencyCode: string = 'KES'; // Default to KES

  private el: HTMLInputElement;
  private onChange = (value: number) => {};
  private onTouched = () => {};

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('input', ['$event'])
  onInput(): void {
    const value = this.el.value;
    const cleaned = value.replace(/[^0-9.]/g, '');
    const parts = cleaned.split('.');
    const integerPart = parts[0] || '';
    const decimalPart = parts[1] ? parts[1].slice(0, 2) : '';

    let formatted = parseInt(integerPart || '0', 10).toLocaleString('en-US');
    if (decimalPart.length > 0) {
      formatted += '.' + decimalPart;
    }

    this.el.value = `${this.currencyCode}${formatted}`;

    const rawNumber = parseFloat(cleaned);
    this.onChange(isNaN(rawNumber) ? 0 : rawNumber);
  }

  @HostListener('blur')
  onBlur(): void {
    this.onTouched();
    const value = this.el.value.replace(/[^0-9.]/g, '');
    const number = parseFloat(value);
    if (!isNaN(number)) {
      this.el.value = number.toLocaleString('en-US', {
        style: 'currency',
        currency: this.currencyCode,
      });
    }
  }

  writeValue(value: number): void {
    if (value !== null && value !== undefined) {
      this.el.value = value.toLocaleString('en-US', {
        style: 'currency',
        currency: this.currencyCode,
      });
    } else {
      this.el.value = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.el.disabled = isDisabled;
  }
}
